/**
 * Canonical public origin — for building absolute URLs the user will SEE
 * (WhatsApp drafts, share text). `ogImages.ts` keeps its own private copy for
 * the og:image pipeline; SEO canonicals come from next-seo config.
 */
export const SITE_ORIGIN = 'https://www.spotme.mx'

/**
 * "Agenda una llamada" on the DIRECTORY ficha's claim section — deliberately
 * Jules's own Calendly, NOT the shared `info.spotme.mx/meetings/spotme/contact`
 * page the rest of the site uses (contact page, help articles, exit-flow modal,
 * step-layout help drawer). The directory claim motion is founder-to-owner and
 * part of Jules's personal sales pipeline (`sales/directory/README.md` → "Claim
 * outreach — the decided motion"), so a facility owner booking from a ficha
 * lands on his calendar directly rather than in the shared round-robin.
 *
 * The `utm_source` rides through to the Calendly invitee record, so a booking
 * that came from a directory ficha is distinguishable from every other booking
 * on that calendar.
 */
export const DIRECTORY_CLAIM_CALL_URL =
  'https://calendly.com/julesb-spotme/30min?utm_source=directorio_ficha'
